<mat-card class="menupannel">
  <div class="resUser">
    <div class="usernameinfo" (click)="openUserDetail()">
      <div class="picname">
        <div class="pic">
          <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
            <img src="{{ ImagePathURL }}" />
          </ng-container>
          <ng-template #showName>
            <span class="shortName">
              {{ getShortName(transactionUserName) }}</span>
          </ng-template>
        </div>
        <div class="name">
          <h3>{{ transactionUserName }}</h3>
          <p>{{ transactionUserRole }}</p>

        </div>
      </div>
    </div>
    <button mat-icon-button (click)="openUserDetail()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
  <div class="d">
    <button mat-flat-button (click)="openContactList()">
      <mat-icon>keyboard_arrow_left</mat-icon> Contacts
    </button>
  </div>
</mat-card>

<div class="showMap"  *ngIf="showMap==true"  [ngClass]="{'active': showMap}" >
    <iframe class="gmap_iframe" 
    width="100%" 
    height="100%" 
    frameborder="0" 
    scrolling="no" 
    marginheight="0" 
    marginwidth="0" 
    [src]="urlSafe"></iframe>


    <div class="closeMap">
      <button mat-icon-button color="primary" (click)="closeMap()" ><mat-icon>close</mat-icon></button>
    </div>

</div>

<div class="coreholder" fxLayout="row">
  <!-- User Detail -->
  <mat-card class="userdetails" [ngClass]="{ open: showUserDetail, expand: expandUserInfo }">
    <div class="forExpansion">
      <div class="usernameinfo">
        <div class="userNameInformation">
          <div class="picname">
            <div class="pic">
              <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
                <img src="{{ ImagePathURL }}" />
              </ng-container>
              <ng-template #showName>
                <span class="shortName">
                  {{ getShortName(transactionUserName) }}</span>
              </ng-template>
              <div class="picuploader">
                <input type="file" alt="" (change)="onSelectFile($event)" />
                <mat-icon>camera_alt</mat-icon>
              </div>
            </div>
            <div class="name">
              <h3>{{ transactionUserName }}</h3>
              <p>{{ transactionUserRole }}</p>
              <!-- <mat-icon *ngIf="showPaycheck==true">local_parking</mat-icon> -->
            </div>
          </div>
  
          <div class="pmenu">
            <button mat-icon-button color="primary" (click)="expandUserDetail()" >
              <mat-icon *ngIf="!expandUserInfo" >chevron_right</mat-icon>
              <mat-icon *ngIf="expandUserInfo">chevron_left</mat-icon>
            </button>                      

                       
            <!--  [matMenuTriggerFor]="menu" <mat-menu #menu="matMenu" xPosition="before">
              <button mat-menu-item><mat-icon>save</mat-icon> Save as template</button>
              <button mat-menu-item><mat-icon>delete_outline</mat-icon> Delete</button>
            </mat-menu> -->
          </div>
          
        </div>
        <!-- Quick action are commented for some time-->
         <!-- class="quick" -->
        <div  style="display:flex;justify-content:space-evenly;margin:5px auto 0px;padding: 2px 0;">

           <!-- <img *ngIf="pendingPatientId!= null" matTooltip="Synced with PointClickCare" style="height: 22px;" src="../../../../assets/icons/pccfavicon-32x32.png"/>
           <img *ngIf="pendingPatientId!= null" matTooltip="Synced with PointClickCare" style="height: 22px;" src="../../../../assets/icons/pccfavicon-gray.png"/>
            -->
            <button mat-icon-button style="margin-top:-5px;" *ngIf="ShowPointClickCare==true" [disabled]="!showPCC" matTooltip="{{pccToolTip}}">
              <img *ngIf="pendingPatientId!= null" (click)="SendtoPendingPatientPCC()" style="height: 22px;margin-top: -10px;"
               src="../../../../assets/icons/pccfavicon-32x32.png"/>

                <img *ngIf="pendingPatientId== null"(click)="SendtoPendingPatientPCC()" style="height: 22px;margin-top: -10px;"
               src="../../../../assets/icons/pccfavicon-gray.png"/>
             </button>
          <!-- <button mat-icon-button matTooltip="Add Document" matTooltipClass="tooltip" ><mat-icon>description</mat-icon></button>
          <button mat-icon-button matTooltip="Add Activity" matTooltipClass="tooltip" ><mat-icon>touch_app</mat-icon></button> -->
          <!-- <button mat-icon-button matTooltip="Add Task" matTooltipClass="tooltip" ><mat-icon>task_alt</mat-icon></button>
          <button mat-icon-button matTooltip="Add Process Intelligence" matTooltipClass="tooltip" ><mat-icon>ac_unit</mat-icon></button>
          <button mat-icon-button matTooltip="Add Photo" matTooltipClass="tooltip" ><mat-icon>add_photo_alternate</mat-icon></button> -->
        </div>
      </div>
  
      
      <ng-container *ngIf="!showTask">
        <div class="compdetail">
          <form [formGroup]="myFormGroup" (ngSubmit)="SaveCoreUserDetails(myFormGroup.value)" id="myForm">
            <ng-container *ngFor="let field of coreUserList">
              <div *ngIf="field.fieldID==0 && field.data.length>0" class="fullw groupHolder"
                [ngSwitch]="field.fieldTypeName">
                <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{field.data[0].groupName}}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngFor="let grpField of field.data">
  
                    <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                      <ng-container *ngSwitchCase="'Textbox'">
                        <ng-container *ngIf="grpField.fieldName == 'Name'">
                          <mat-form-field>
                            <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}"
                              [(ngModel)]="transactionUserName" formControlName="{{ grpField.fieldName }}"
                              [readonly]="grpField.rolePermission==1" />
  
  
                          </mat-form-field>
                        </ng-container>
  
                        <ng-container *ngIf="grpField.fieldName != 'Name'">
                          <ng-container *ngIf="grpField.fieldNames.length > 0">
                            <div class="multipleBlock">
                              <div class="multype">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{ grpField.fieldName + 'option' }}"
                                    placeholder="{{ grpField.placeholderVal }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of grpField.fieldNames">
                                      {{ names.fieldName }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                  <input [required]="grpField.isRequired" *ngIf="grpField.fieldName == 'Phone'" matInput
                                    placeholder="Add Phone" [(ngModel)]="grpField.fieldValue"
                                    formControlName="{{ grpField.fieldName }}" mask="(000) 000-0000"
                                    [readonly]="grpField.rolePermission==1" />
                                  <input [required]="grpField.isRequired" *ngIf="grpField.fieldName != 'Phone'" matInput
                                    placeholder="Add {{ grpField.placeholder }}" [(ngModel)]="grpField.fieldValue"
                                    formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                </mat-form-field>
  
                                <div class="inOline" *ngIf="grpField.fieldName == 'Address'">
  
                                  <div class="divide">
                                    <mat-form-field>
                                      <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number"
                                        matInput (input)="searchCity($event.target.value)" formControlName="City"
                                        [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                      <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of cityOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
  
                                  <div class="divide">
                                    <mat-form-field>
                                      <mat-select [disabled]="grpField.rolePermission==1" [(ngModel)]="stateValue"
                                        formControlName="State" placeholder="State">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
  
                                  <div class="divide">
                                    <mat-form-field>
                                      <input type="text" placeholder="Zip Code" aria-label="Number" [(ngModel)]="zipValue"
                                        matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                        [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                      <mat-autocomplete #ZipCode="matAutocomplete">
                                        <mat-option *ngFor="let option of zipOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
  
  
                                </div>
  
  
                              </div>
                              <span class="addmore" (click)="addMore(grpField.fieldName)"
                                *ngIf="grpField.fieldNames.length > 0">
                                Add more</span>
                            </div>
  
                            <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">
                              <div class="multype" *ngFor="let element of dynamicArray; let i = index">
  
  
                                <div class="primaryEmail">
                                  <mat-form-field class="mulDropdown" appearance="">
                                    <mat-select (selectionChange)="clearPlaceholder($event)"
                                      formControlName="{{element.fieldName + 'option'}}"
                                      placeholder="{{ element.placeholderVal }}">
                                      <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of element.fieldNames;
                                          trackby: fieldNameID">{{ names.fieldName }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
  
                                  <!-- <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"> Primary</div> -->
  
                                </div>
  
                                <mat-form-field>
                                  <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName}}" [readonly]="grpField.rolePermission==1"
                                    pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                                </mat-form-field>
  
                              </div>
                              <span class="addmore" (click)="addMore(grpField.fieldName)"
                                *ngIf="grpField.fieldNames.length > 0">
                                Add more</span>
                            </div>
  
                            <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                              <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                      element.fieldName  + 'option'
                                    }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field>
                                  <input matInput mask="(000) 000-0000" [(ngModel)]="element.fieldValue"
                                    placeholder="Add Phone" formControlName="{{ element.fieldName }}"
                                    [readonly]="grpField.rolePermission==1" />
                                </mat-form-field>
  
  
                              </div>
                              <span class="addmore" (click)="addMore(grpField.fieldName)"
                                *ngIf="grpField.fieldNames.length > 0">
                                Add more</span>
                            </div>
  
                            <div class="multipleBlock" *ngIf="grpField.fieldName == 'Address'">
                              <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{
                                      element.fieldName + 'option'
                                    }}" placeholder="{{ element.placeholderVal }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
  
                                <mat-form-field>
                                  <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                </mat-form-field>
  
                                <div *ngIf="element.address.length>0" class="inOline">
                                  <ng-container *ngFor=" let adr of element.address;">
  
  
                                    <!-- <div class="divide">
                                    <mat-form-field> -->
                                    <input *ngIf="adr.childFieldType==3" placeholder="City" aria-label="Number" matInput
                                      [ngModel]="adr.fieldValue" (input)="searchCity($event.target.value)"
                                      formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                      [readonly]="grpField.rolePermission==1">
                                    <mat-autocomplete #auto="matAutocomplete">
                                      <mat-option *ngFor="let option of cityOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <!-- </mat-form-field>
                                  </div> -->
  
                                    <!-- <div class="divide">
                                    <mat-form-field> -->
                                    <mat-select [disabled]="grpField.rolePermission==1" [ngModel]="adr.fieldValue"
                                      *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}"
                                      placeholder="State">
                                      <mat-option>None</mat-option>
                                      <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                    </mat-select>
                                    <!-- </mat-form-field>
                                  </div> -->
  
  
                                    <!-- <div class="divide">
                                    <mat-form-field> -->
                                    <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                      aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                      formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                      [readonly]="grpField.rolePermission==1">
                                    <mat-autocomplete #ZipCode="matAutocomplete">
                                      <mat-option *ngFor="let option of zipOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <!-- </mat-form-field>
                                  </div> -->
  
  
                                  </ng-container>
                                </div>
                                <div *ngIf="element.address.length==0" class="inOline">
  
                                  <div class="divide">
                                    <mat-form-field>
                                      <input placeholder="City" aria-label="Number" matInput
                                        (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                        [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                      <mat-autocomplete #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of cityOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
  
                                  <div class="divide">
                                    <mat-form-field>
                                      <mat-select [disabled]="grpField.rolePermission==1"
                                        formControlName="State{{ (i + 1) }}" placeholder="State">
                                        <mat-option>None</mat-option>
                                        <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
  
                                  <div class="divide">
                                    <mat-form-field>
                                      <input placeholder="Zip Code" aria-label="Number" matInput
                                        (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                        [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                      <mat-autocomplete #ZipCode="matAutocomplete">
                                        <mat-option *ngFor="let option of zipOption" [value]="option">
                                          {{option}}
                                        </mat-option>
                                      </mat-autocomplete>
                                    </mat-form-field>
                                  </div>
  
  
  
  
                                </div>
  
                              </div>
                              <span class="addmore" (click)="addMore(grpField.fieldName)"
                                *ngIf="grpField.fieldNames.length > 0">
                                Add more</span>
                            </div>
  
                            <div class="multipleBlock" *ngIf="grpField.fieldName == 'WebSite'">
                              <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                      element.fieldName + 'option'
                                    }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
  
  
                                <mat-form-field>
                                  <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                                    formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                </mat-form-field>
  
  
                              </div>
                              <span class="addmore" (click)="addMore(grpField.fieldName)"
                                *ngIf="grpField.fieldNames.length > 0">
                                Add more</span>
                            </div>
                          </ng-container>
  
                          <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                            <mat-label>{{ grpField.fieldName }}</mat-label>
                            <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}"
                              formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                          </mat-form-field>
                        </ng-container>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Textarea'">
                        <mat-form-field>
                          <textarea [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                            formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1">
                          </textarea>
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Number'">
                        <mat-form-field>
                          <input [required]="grpField.isRequired" matInput (keypress)="numberOnly($event)"
                            placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                            [readonly]="grpField.rolePermission==1" />
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Currency'">
                        <mat-form-field>
                          <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                            formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Address'">
                        <mat-form-field>
                          <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                            formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Image'">
                        <mat-label>{{ grpField.fieldName }}</mat-label>
                        <div class="pic">
                          <input type="file" placeholder="{{ grpField.fieldName }}"
                            formControlName="{{ grpField.fieldName }}" (change)="onSelectFile($event)"
                            [readonly]="grpField.rolePermission==1" />
                          <span class="ico">
                            <mat-icon>add_a_photo</mat-icon>
                          </span>
                        </div>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Date'">
                        <mat-form-field>
                          <mat-label>{{ grpField.fieldName }}</mat-label>
                          <input [required]="grpField.isRequired" matInput [matDatepicker]="basicDatepicker"
                            placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                            [readonly]="grpField.rolePermission==1" />
                          <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                          <mat-datepicker #basicDatepicker></mat-datepicker>
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'URL'">
                        <mat-form-field>
                          <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                            formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'Dropdown'">
                        <mat-form-field>
                          <mat-label>{{ grpField.fieldName }}</mat-label>
                          <mat-select [disabled]="grpField.rolePermission==1"
                            [ngModel]="getddlSelectedVal(grpField.fieldName)" [required]="grpField.isRequired"
                            formControlName="{{ grpField.fieldName }}">
                            <mat-option *ngFor="let drp of getdropdownlist(grpField.fieldName)" [value]="drp">
                              {{ drp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'MultiSelect'">
                        <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                          <mat-label>{{ grpField.fieldName }}</mat-label>
                          <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                            <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                              (removed)="remove(tag)">
                              {{tag}}
                              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                              (matChipInputTokenEnd)="add($event)">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                            <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                              {{tag}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
  
                        <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                          <mat-label>{{ grpField.fieldName }}</mat-label>
                          <mat-select [disabled]="grpField.rolePermission==1" [required]='grpField.isRequired' multiple
                            [ngModel]="getMultiddlSelectedVal(grpField.fieldName)"
                            formControlName="{{ grpField.fieldName }}">
                            <mat-option *ngFor="
                                let muldrp of getMuldropdownlist(grpField.fieldName)
                              " [value]="muldrp">
                              {{ muldrp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
  
                      </ng-container>
  
                      <!-- <ng-container *ngSwitchCase="'MultiSelect'">
                        <mat-form-field>
                          <mat-label>{{ grpField.fieldName }}</mat-label>
                          <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired"
                          [ngModel]="getMultiddlSelectedVal(grpField.fieldName)" multiple formControlName="{{ grpField.fieldName }}">
                            <mat-option
                              *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)"
                              [value]="muldrp">
                              {{ muldrp }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container> -->
  
                      <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName ==='Tags'">
                        <mat-form-field class="example-chip-list">
                          <mat-label>{{ grpField.fieldName }}</mat-label>
                          <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Fruit selection">
                            <mat-chip
                              *ngFor="let fruit of filteredFruits"
                              [selectable]="selectable"
                              [removable]="removable"
                              (removed)="remove(fruit)">
                              {{fruit}}
                              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input
                              placeholder="Add Tags"
                              #fruitInput
                              [formControl]="fruitCtrl"
                              [matAutocomplete]="auto"
                              [matChipInputFor]="chipList"
                              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                              (matChipInputTokenEnd)="add($event)"
                              [readonly] = "grpField.rolePermission==1">
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                            <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                              {{fruit}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </ng-container>                     -->
  
  
                      <ng-container *ngSwitchCase="'Checkbox'">
                        <mat-label>{{ grpField.fieldName }}</mat-label>
                        <ul class="check">
                          <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                            <mat-checkbox color="primary" [disabled]="grpField.rolePermission==1"
                              [checked]="isChecked(grpField.fieldName, chk)"
                              (change)="OnChange($event, chk, grpField.fieldID)">
                              {{ chk }}
                            </mat-checkbox>
                          </li>
                        </ul>
                      </ng-container>
  
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
  
              <div [ngSwitch]="field.fieldTypeName" class="fullw" *ngIf="field.fieldID > 0">
  
                <div *ngSwitchCase="'Textbox'">
  
                  <ng-container *ngIf="field.fieldNames.length > 0">
                    <ng-container>
                      <div class="multipleBlock">
                        <div class="multype">
                         
                          <div class="forAddress">
                           
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select [ngModel]="field.fieldNameID" formControlName="{{ field.fieldName + 'option' }}">
                                <mat-option [value]="names.fieldNameID" *ngFor="
                                    let names of field.fieldNames;
                                    trackby: fieldNameID
                                  ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          
  
                          </div>
                          <mat-form-field>
                            <input [required]='field.isRequired' *ngIf="field.fieldName == 'Phone'" matInput
                              placeholder="Add Phone" [(ngModel)]="field.fieldValue"
                              formControlName="{{ field.fieldName }}" mask="(000) 000-0000"
                              [readonly]="field.rolePermission==1" />
                            <input [required]='field.isRequired' *ngIf="field.fieldName == 'Email'" matInput
                              placeholder="Add Email" [(ngModel)]="field.fieldValue"
                              formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                            <input [required]='field.isRequired' *ngIf="field.fieldName == 'Address'" matInput
                              placeholder="Add Address" [(ngModel)]="field.fieldValue"
                              formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
  
                              <div class="" *ngIf="field.fieldName == 'Address'">
  
    
                                <button type="button" mat-icon-button class="addressPin" (click)="showLocationOnMap(field.fieldValue)">
                                  <mat-icon>pin_drop</mat-icon>
                                </button> 
        
                              </div>
  
  
                          </mat-form-field>
  
                          <!-- <mat-form-field>
                            <input [required]='field.isRequired'
                            *ngIf="field.fieldName == 'Phone'"
                            matInput
                            placeholder="Add Phone"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"
                            mask="(000) 000-0000"
                            [readonly] = "field.rolePermission==1"
                          />
                          <input [required]='field.isRequired'
                            *ngIf="field.fieldName == 'Email'"
                            matInput
                            placeholder="Add Email"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"                        
                            [readonly] = "field.rolePermission==1"
                            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                          />
                          <input [required]='field.isRequired'
                            *ngIf="field.fieldName != 'Phone' && field.fieldName != 'Email' "
                            matInput
                            placeholder="Add {{field.placeholder}}"
                            [(ngModel)]="field.fieldValue"
                            formControlName="{{ field.fieldName }}"
                            [readonly] = "field.rolePermission==1"
                          />
                          </mat-form-field> -->
  
                          <!-- // -->
                          <div *ngIf="field.fieldName == 'Address'" class="inOline">
  
                            <div class="divide">
                              <mat-form-field>
                                <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number" matInput
                                  (input)="searchCity($event.target.value)" formControlName="City"
                                  [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                                <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of cityOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
  
                            <div class="divide">
                              <mat-form-field>
  
                                <mat-select [disabled]="field.rolePermission==1" [(ngModel)]="stateValue"
                                  formControlName="State" placeholder="State">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
  
                            <div class="divide">
                              <mat-form-field>
                                <input type="text" [(ngModel)]="zipValue" placeholder="Zip Code" aria-label="Number"
                                  matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                  [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                                <mat-autocomplete #ZipCode="matAutocomplete">
                                  <mat-option *ngFor="let option of zipOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
  
  
  
  
                          </div>
                          <!-- <input *ngIf="field.fieldName == 'Address'"
                          class="addinput"
                          placeholder="Add Country"
                          [(ngModel)]="countryValue"
                          formControlName="Country"
                        /> -->
                          <!-- // -->
  
                        </div>
                        <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                          Add more
                        </span>
                      </div>
                      <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">
                        <div class="multype" *ngFor="let element of dynamicArray; let i = index">
  
                          <div class="primaryEmail">
  
                            <mat-form-field class="mulDropdown" appearance="">
                              <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                formControlName="{{ element.fieldName + 'option' }}"
                                placeholder="{{ element.placeholderVal }}">
                                <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                    let names of element.fieldNames;
                                    trackby: fieldNameID
                                  ">{{ names.fieldName }}</mat-option>
                              </mat-select>
                            </mat-form-field>
  
                            <!-- <div class="setPrimary"  matTooltip="Set as primary email" matTooltipClass="tooltip"> Primary</div> -->
  
                          </div>
  
                          <mat-form-field>
                            <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                              formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1"
                              pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                          </mat-form-field>
  
                        </div>
                        <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                          Add more
                        </span>
                      </div>
  
                      <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                        <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{ element.fieldName + 'option' }}"
                              placeholder="{{ element.placeholderVal }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>
  
                          <mat-form-field>
                            <input matInput placeholder="Add Phone" [(ngModel)]="element.fieldValue"
                              formControlName="{{ element.fieldName }}" mask="(000) 000-0000"
                              [readonly]="field.rolePermission==1" />
                          </mat-form-field>
  
  
  
                        </div>
                        <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                          Add more
                        </span>
                      </div>
  
                      <div class="multipleBlock" *ngIf="field.fieldName == 'Address'">
                        <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{ element.fieldName + 'option' }}"
                              placeholder="{{ element.placeholderVal }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>
  
                          <mat-form-field>
                            <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                              formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1" />
                          </mat-form-field>
  
                          <div *ngIf="element.address.length>0" class="inOline">
                            <ng-container *ngFor=" let adr of element.address;">
  
  
                              <!-- <div class="divide">
                                <mat-form-field> -->
                              <input *ngIf="adr.childFieldType==3" placeholder="City" [ngModel]="adr.fieldValue"
                                aria-label="Number" matInput (input)="searchCity($event.target.value)"
                                formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                [readonly]="field.rolePermission==1">
                              <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of cityOption" [value]="option">
                                  {{option}}
                                </mat-option>
                              </mat-autocomplete>
                              <!-- </mat-form-field>
                              </div> -->
  
                              <!-- <div class="divide">
                                <mat-form-field> -->
                              <mat-select [disabled]="field.rolePermission==1" [ngModel]="adr.fieldValue"
                                *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}" placeholder="State">
                                <mat-option>None</mat-option>
                                <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                              </mat-select>
                              <!-- </mat-form-field>
                              </div> -->
  
                              <!-- <div class="divide">
                                <mat-form-field> -->
                              <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                [readonly]="field.rolePermission==1">
                              <mat-autocomplete #ZipCode="matAutocomplete">
                                <mat-option *ngFor="let option of zipOption" [value]="option">
                                  {{option}}
                                </mat-option>
                              </mat-autocomplete>
                              <!-- </mat-form-field>
                              </div> -->
  
  
                            </ng-container>
  
                          </div>
                          <div *ngIf="element.address.length==0" class="inOline">
  
  
  
                            <div class="divide">
                              <mat-form-field>
                                <input placeholder="City" aria-label="Number" matInput
                                  (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                  [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                                <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of cityOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
  
  
                            <div class="divide">
                              <mat-form-field>
                                <mat-select [disabled]="field.rolePermission==1" formControlName="State{{ (i + 1) }}"
                                  placeholder="State">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
  
  
                            <div class="divide">
                              <mat-form-field>
                                <input placeholder="Zip Code" aria-label="Number" matInput
                                  (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                  [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                                <mat-autocomplete #ZipCode="matAutocomplete">
                                  <mat-option *ngFor="let option of zipOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
  
  
  
  
                          </div>
  
  
                        </div>
                        <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                          Add more
                        </span>
                      </div>
  
                      <div class="multipleBlock" *ngIf="field.fieldName == 'WebSite'">
                        <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{
                                element.fieldName + 'option'
                              }}" placeholder="{{ element.placeholderVal }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>
  
                          <mat-form-field>
                            <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                              formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="field.rolePermission==1" />
                          </mat-form-field>
  
  
  
                        </div>
                        <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                          Add more
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
  
                  <mat-form-field *ngIf="field.fieldName == 'Name'">
                    <input matInput [required]="field.isRequired" [(ngModel)]="transactionUserName"
                      placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1" />
                    <mat-error *ngIf="
                        myFormGroup.get(field.fieldName).invalid &&
                        (myFormGroup.get(field.fieldName).dirty ||
                          myFormGroup.get(field.fieldName).touched)
                      ">
                      <span *ngIf="myFormGroup.get(field.fieldName).errors.required">This field is mandatory.</span>
                    </mat-error>
                  </mat-form-field>
  
                  <mat-form-field *ngIf="
                      field.fieldNames.length === 0 && field.fieldName != 'Name'
                    ">
  
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                      placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1" />
                  </mat-form-field>
  
                </div>
  
                <div *ngSwitchCase="'Textarea'">
                  <mat-form-field>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <textarea [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                      placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1"></textarea>
                  </mat-form-field>
                </div>
  
                <div *ngSwitchCase="'Number'">
                  <mat-form-field>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input [required]='field.isRequired' matInput (keypress)="numberOnly($event)"
                      placeholder="{{ field.fieldName }}" [(ngModel)]="field.fieldValue"
                      formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                  </mat-form-field>
                </div>
  
                <div *ngSwitchCase="'Currency'">
                  <mat-form-field>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                      [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1" />
                  </mat-form-field>
                </div>
  
                <div *ngSwitchCase="'Address'">
                  <mat-form-field>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                      [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1" />
                  </mat-form-field>
                </div>
  
                <div *ngSwitchCase="'URL'" class="po_rl" >
                  <mat-form-field>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                      placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1" />
                  </mat-form-field>

                  <button class="po_ab_rht_0" color="primary" mat-icon-button (click)="openFieldURL(field.fieldValue)" ><mat-icon>link</mat-icon></button>

                </div>
  
                <div *ngSwitchCase="'Date'">
                  <mat-form-field>
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <input [required]='field.isRequired' matInput [matDatepicker]="basicDatepicker"
                      [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                      [readonly]="field.rolePermission==1" />
                      <mat-icon *ngIf="field.fieldValue" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate(field)">clear</mat-icon>
                    <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #basicDatepicker></mat-datepicker>
                  </mat-form-field>
                </div>
  
  
  
                <ng-container *ngSwitchCase="'Dropdown'">
                  <mat-form-field *ngIf="field.fieldName == 'Type'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [required]='field.isRequired' [(ngModel)]="TypeIdDrp"
                      formControlName="{{ field.fieldName }}"
                      (selectionChange)="getCoreUserDetailsOnTypeChange($event,field.fieldName)">
                      <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                        {{typelist.folderName}}
                      </mat-option>
                    </mat-select>
  
                  </mat-form-field>
  
                  <mat-form-field *ngIf="field.fieldName != 'Type'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [required]='field.isRequired' [ngModel]="getddlSelectedVal(field.fieldName)"
                      formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                      <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                        {{ drp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
  
  
                <ng-container *ngSwitchCase="'MultiSelect'">
  
                  <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
                      <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                        (removed)="remove(tag)">
                        {{tag}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                      <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                        {{tag}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
  
                  <mat-form-field *ngIf="field.fieldName != 'Tags'">
                    <mat-label>{{ field.fieldName }}</mat-label>
                    <mat-select [required]='field.isRequired' multiple [ngModel]="getMultiddlSelectedVal(field.fieldName)"
                      formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                      <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                        {{ muldrp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
  
  
                <ng-container *ngSwitchCase="'Checkbox'">
                  <div class="checkList">
                    <mat-label>{{ field.fieldName }}</mat-label>
  
                    <div class="allCheckList" *ngFor="let chk of getCheckBoxlist(field.fieldName)">
                      <mat-checkbox color="primary" [disabled]="field.rolePermission==1"
                        [checked]="isChecked(field.fieldName, chk)" (change)="OnChange($event, chk, field.fieldID)">
                        {{ chk }}
                      </mat-checkbox>
                    </div>
                  </div>
                </ng-container>
  
              </div>
            </ng-container>
  
  
          </form>
  
  
        </div>
        <div class="actionBtn" [ngClass]="{'dirty': myFormGroup.dirty}" *ngIf="myFormGroup.dirty || myFormGroup.invalid">
          <button mat-stroked-button class="cancel" (click)="revertForm()">Cancel</button>
            <button mat-flat-button class="calltoaction" [disabled]="!myFormGroup.dirty"
              type="submit" color="accent" form="myForm">
              Save
            </button>
        </div>
      </ng-container>
  
      <ng-container *ngIf="showTask">
        <app-task3c-tasklists class="inCore" [transactionID]="getTransactionID()" [typeId]="typeIdForTask"
          (OpenTaskLists)="OpenTaskLists($event)" [modulename]="Module" [mainModulename]="mainModuleName"
          (getMyTask)="getMyTask()" [name]="NameForTask" [email]="EmailForTask"
          [imageUrl]="ImageForTask" [entityId]="entityId"  [TypeIdDrp]="TypeIdDrp">
        </app-task3c-tasklists>
      </ng-container>
    </div>

  </mat-card>

  <div class="userdetailsOverlay" (click)="openUserDetail()" [ngClass]="{ open: showUserDetail }">
  </div>



  <!-- User Detail -->

  <!-- Core page Structure -->
  <div class="corepages">

    
  <div class="allFormHolder">
    
    <div class="allforms">

      <!-- <div class="formBtn">
        <button mat-icon-button (click)="openHTML()" ><mat-icon>draw</mat-icon></button>
        <span>Notes</span>
      </div>   -->
      
      <div class="formBtn" *ngFor="let record of FormReportfolderList">

        
        <button mat-icon-button (click)="openHTML(record)" matTooltip="{{record.formAlias}}">
          <mat-icon>{{record.formIcon}}</mat-icon>  </button>
          <span>{{record.formAlias}}</span>          
      

        <!-- <button mat-icon-button (click)="openHTML(record)"><mat-icon>{{record.formIcon}}</mat-icon></button>
        <span>{{record.formIcon}}</span> -->
      </div>  

      <!-- <div class="formBtn">
        <button mat-icon-button ><mat-icon>draw</mat-icon></button>
        <span>Meeting</span>
      </div>   -->
        <!-- <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>draw</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
        <button mat-icon-button matTooltip="form name" ><mat-icon>border_right</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>font_download</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>rectangle</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>align_vertical_top</mat-icon></button>

        <button mat-icon-button matTooltip="form name"><mat-icon>draw</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button> -->
        <!-- <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>font_download</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>rectangle</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>align_vertical_top</mat-icon></button> -->

        <!-- <button mat-icon-button matTooltip="form name"><mat-icon>draw</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>text_snippet</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>view_agenda</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>format_align_center</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>font_download</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>rectangle</mat-icon></button>
        <button mat-icon-button matTooltip="form name"><mat-icon>border_right</mat-icon></button>
        <button mat-icon-button matTooltip="form name"  ><mat-icon>align_vertical_top</mat-icon></button> -->
    </div>

    <!-- <div class="arwformbtn">
      <button mat-icon-button ><mat-icon>keyboard_arrow_left</mat-icon></button>
      <button mat-icon-button ><mat-icon>keyboard_arrow_right</mat-icon></button>
    </div> -->

  </div>

    <div class="nextpreviuos">
      <!-- <button mat-button color="primary" [disabled]="PreviousButton" (click)="PreviousRecord()">
      Previous     
    </button>  -->

      <button mat-icon-button [disabled]="PreviousButton" (click)="PreviousRecord()" matTooltipClass="tooltip"
        matTooltip="Previous">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>

      <button mat-icon-button [disabled]="NextButton" (click)="NextRecord()" matTooltipClass="tooltip"
        matTooltip="Next">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
      <!-- <button mat-button color="primary" [disabled]="NextButton" (click)="NextRecord()">
      Next     
    </button>  -->
    </div>

    <!-- <mat-tab-group animationDuration="0ms" (selectedTabChange)="getAllFoldersFieldNew($event)"
      [selectedIndex]="matTabIndex">     
     
      <mat-tab *ngFor="let subModule of SubMenuModulesList" [label]="subModule.orgModuleName">       
      </mat-tab>
      
    </mat-tab-group> -->

    <mat-tab-group animationDuration="0ms" (selectedTabChange)="getAllFoldersFieldNew($event,SubMenuModulesList)"
      [selectedIndex]="matTabIndex">

    <ng-container *ngFor="let subModule of SubMenuModulesList">

      <mat-tab *ngIf="subModule.mainModuleName === 'DOCUMENTS'" [label]="subModule.orgModuleName">
        <app-documents
          (openBindFieldDetail)="getBindFieldDetail($event)" 
          (openAIDetail)="getAIDetails($event)" 
          (openDocumentDetail)="getDocumentDetail($event)"
          (showShareFile)="getShareFile($event)"
          (showShareFaxFile)="getShareFaxFile($event)"
          (documentViewer)="getdocumentViewer($event)"
          (htmlData)="gethtmlData($event)"
          [transactionID]="getTransactionID()"
          [folderID]="folderID"         
          [modulename]="Module"
          [mainModulename]="mainModuleName"
          [transactionIDs]="transactionIDForTask"
          [typeId]="typeIdForTask"
          [name]="NameForTask"
          [email]="EmailForTask"
          [imageUrl]="ImageForTask"
          [status]="statusType">
        </app-documents>
      </mat-tab>

      <mat-tab *ngIf="subModule.mainModuleName === 'ACTIVITY'" [label]="subModule.orgModuleName">
        <app-touches *ngIf="showTouches"></app-touches>
      </mat-tab>


      <mat-tab *ngIf="subModule.mainModuleName === 'CUSTOM INFO'" [label]="subModule.orgModuleName">
        <app-customInfo3c *ngIf="showCustomInfo" [mainModulename]="mainModuleName"></app-customInfo3c>
      </mat-tab>


      <mat-tab *ngIf="subModule.mainModuleName === 'TASKS'" [label]="subModule.orgModuleName">
        <app-task3c *ngIf="showTask" [modulename]="Module" [mainModulename]="mainModuleName"
          [transactionID]="transactionIDForTask" [typeId]="typeIdForTask" [name]="NameForTask" [email]="EmailForTask"
          [imageUrl]="ImageForTask" [entityId]="entityId"  [TypeIdDrp]="TypeIdDrp">
        </app-task3c>
      </mat-tab>


      <mat-tab *ngIf="subModule.mainModuleName === 'EMAIL'" [label]="subModule.orgModuleName">
        <app-email *ngIf="showEmail" [mainModulename]="mainModuleName"></app-email>
      </mat-tab>


      <mat-tab *ngIf="subModule.mainModuleName === 'FORM REPORTS'" [label]="subModule.orgModuleName">
        <app-htmlReport3c *ngIf="showFormReports" [mainModulename]="mainModuleName">

        </app-htmlReport3c>
        <!-- <p>Form reports content here...</p> -->
        <!-- <app-formReports *ngIf="showFormReports"       
        (htmlData)="gethtmlData($event)"              
        [modulename]="Module"
        [mainModulename]="mainModuleName"
        [FormFolderReportList]="FormFolderReportList"> -->
      <!-- </app-formReports> -->
      </mat-tab>


      <mat-tab *ngIf="subModule.mainModuleName === 'MEDICATIONS'" [label]="subModule.orgModuleName">
        <mat-card class="filter" >
          
          <span></span>
          <div class="medication-container">
            <button mat-button color="primary" (click)="openEditDialog(0)"><mat-icon>add</mat-icon>Medication</button>
            <button class="medication-sync-button" (click)="OpenMedicationPopUP(AddCarePeriod)" [disabled]="!showSyncButton" id="syncmedicationToPCC">
              <svg class="medication-sync-icon" viewBox="0 0 24 24">
                  <path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31
                   2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 
                   0-1.57-.46-3.03-1.24-4.26z"/>
              </svg>
              Sync to PointClickCare
          </button>
          </div>
        </mat-card>
        <div class="medication-table">
          <table >
            <thead>
                <tr> 
                <th>  
                <mat-checkbox color="primary" (change)="CheckAllBoxes($event.checked)">
                
                </mat-checkbox>
                </th>
                    <th>Sync</th>
                    <th>Name</th>   
                    <th>Route</th>                
                    <th>Dosage</th>
                    <th>Freq.</th>                  
                    <th>Schedule</th>
                    <th>Sche.Type</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let medicine of medicationList"  [class.invalid-medication]="medicine.not_valid" [ngStyle]="{'background-color': (medicine.status | lowercase) != 'current' ? '#eabcab;' : ''}">
                    <td class="medication-sync">
                      <mat-checkbox (change)="CheckMedicationBox($event.checked,medicine)" [checked]="medicine.checked" color="primary" class="medication_chk"  >
                      </mat-checkbox>
                    </td>
                    <td class="medication-sync" *ngIf="medicine.isSynced==1"><mat-icon style="color:orange">schedule</mat-icon></td>
                    <td class="medication-sync" *ngIf="medicine.isSynced==3" (click)="showError(medicine.errorJson)"><mat-icon style="color:red; cursor:pointer;">error</mat-icon></td>
                    <td class="medication-sync" *ngIf="medicine.isSynced==2"><mat-icon style="color:#6edb6e">check_circle_outline</mat-icon></td>
                    <td class="medication-name">{{medicine.name}}</td>
                    <td class="medication-route">{{medicine.route}}</td> 
                    <td class="medication-dosage">{{medicine.modifiedDose}}</td>
                    <td class="medication-frequency">{{medicine.frequency}}</td>
                    <td class="medication-type">{{medicine.schedule}}</td>
                    <td class="medication-type">{{medicine.scheduleType}}</td> 
                    <td class="medication-route">{{medicine.status}}</td>
                    <td class="medication-date">{{medicine.startDate}}</td>
                    <td class="medication-not-provided">{{medicine.endDate}}</td>
                    <td> 
                      <!-- (click)="openEditDialog(medicine.medicationID)" -->
                      <button mat-icon-button class="editbtn" (click)="openEditDialog(medicine.medicationID)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <!-- <button mat-icon-button class="trash" (click)="deleteMedication(medicine.medicationID)">
                        <mat-icon>delete_outline</mat-icon>
                      </button> -->
                   
                  </td>
                </tr>
            </tbody>
        </table>
        </div>
            
            
      </mat-tab> 

      <!-- <mat-tab label="Task">
        <app-task
          (createTask)="getcreateTask($event)"
          (showLinkPI)="getLinkPI($event)"
          (taskDetail)="getTaskDetail($event)"
        ></app-task>
      </mat-tab> -->

      <!-- <mat-tab label="Process Intelligence">
        <app-process-intelligence></app-process-intelligence>
      </mat-tab>

      <mat-tab label="Photos">
        <app-photos></app-photos>
      </mat-tab>

      <mat-tab label="Shared">
        <app-request-document></app-request-document>
      </mat-tab> -->
  
    </ng-container>

    </mat-tab-group>



  </div>

  <!-- Core page Structure -->
  <!-- Contact List -->
  <mat-card class="contactlist" [ngClass]="{ open: showContactList }">

    <app-associate-core [datalist]="contactCoreListing" [coreID]="transactionID"
    [TypeIdDrp]="TypeIdDrp"></app-associate-core>

  </mat-card>

  <div class="contactlistOverlay" (click)="openContactList()" [ngClass]="{ open: showContactList }">
  </div>

  <!-- Contact List -->

  <!-- All OTHER COMPONENETS -->

  <!-- Create Activity -->
  <app-create-touches (closeShowCreate)="closeTouches($event)" [ngClass]="{ open: showCreateTouches }">
  </app-create-touches>
  <!-- Create Activity -->

  <!-- document detail -->

  <!-- <app-bind-fields-ai
    [ngClass]="{ open: openbindFieldsDetail }"
    (bindFieldViewer)="getAIDetail($event)"
    (closeBindEmit)="getCloseBindFieldDetail()"
    [folderID]="folderID">
  </app-bind-fields-ai> -->

  <app-bind-field-ai
    [ngClass]="{ open: openbindFieldsDetail }"
    (bindFieldViewer)="getAIDetail($event)"
    (closeBindEmit)="getCloseBindFieldDetail()"
    [folderID]="folderID"
    [modulename]="Module"
    [mainModulename]="mainModuleName"
    [transactionID]="transactionIDForTask"
    [typeId]="typeIdForTask"
    [name]="NameForTask"
    [email]="EmailForTask"
    [imageUrl]="ImageForTask"
    [status]="statusType">
  </app-bind-field-ai>

 <app-ai-details *ngIf="openAIToolDetail"
[ngClass]="{ open: openAIToolDetail }"
[pdfURL]="azureblobPath"
[documentId]="documentsId"
[typeIdCCC]="typeIdForTask"
[documentName]="documentNames"
[cType]="cType"
[transactionID3c]="transactionIDForTask"
[docFrom]="cType"
[Name]="NameForTask"
[Email]="EmailForTask"
(closeAIToolEmit)="getCloseAIToolDetail()">
</app-ai-details>

  <!-- document detail-->

  <!-- document detail -->

  <app-documentdetail
    [ngClass]="{ open: openDocumentDetail }"
    (openAIDetailfromDocDetails)="getAIDetailsFromDocDetails($event)"
    (documentViewer)="getdocumentViewer($event)"
    (closeEmit)="getClose($event)">
  </app-documentdetail>

  <!-- document detail-->

  <!-- Document Viewer -->
  <app-document-viewer (getCloseDocumentViewer)="getCloseDocumentViewer($event)" [ngClass]="{ open: documentViewer }"
    [folderID]="folderID">
  </app-document-viewer>
  <!-- Document Viewer-->

  <!-- Share Document -->


  <!-- Document Viewer -->
  <app-html-data (getCloseHtmlData)="getCloseHtmlData($event)" [ngClass]="{ open: htmlData }" [folderID]="folderID">
  </app-html-data>
  <!-- Document Viewer-->

  <app-fax-File [mainModuleName]="mainModuleName" [ngClass]="{ open: showShareFaxFile }"
    (closeShareFile)="getCloseShareFaxFile($event)">
  </app-fax-File>

  <app-request-File [mainModuleName]="mainModuleName" [ngClass]="{ open: showShareFile }"
    (closeShareFile)="getCloseShareFile($event)">
  </app-request-File>



  <!-- Contact Detail -->
  <app-contact-detail *ngIf="showContactdetail" (closeDetail)="getCloseDetail($event)"
    [ngClass]="{ open: showContactdetail }">
  </app-contact-detail>
  <!-- Contact Detail -->

  <!-- Create Task -->
  <app-create-task [ngClass]="{ open: showCreateTask }" (closeCreateTask)="closeCreateTask($event)">
  </app-create-task>
  <!-- Create Task -->

  <!-- In Task LINK PI -->
  <app-task-detail [ngClass]="{ open: showTaskDetail }" (closeTaskDetail)="closeTaskDetail($event)">
  </app-task-detail>
  <!-- In Task LINK PI -->

  <!-- In Task LINK PI -->
  <app-link-pi [ngClass]="{ open: showLinkPI }" (closeLinkPI)="closeLinkPI($event)">
  </app-link-pi>
  <!-- In Task LINK PI -->

  <ng-template #AddCarePeriod>
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>group_add</mat-icon>
      </span>
      Add/Select CarePeriod
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
  
    <mat-dialog-content class="mat-typography">
     
      

        <div class="popup-section medication-section">

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="carePeriodSelect">Select Care Period:</label>
                <select id="carePeriodSelect" class="form-control" (change)="onCarePeriodSelect($event)">
                  <option value="0">Select Care Period</option>
                  <option *ngFor="let period of carePeriodList" [value]="period.pccPeriodID">{{period.carePeriodName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6 pushbuttontobottom">
              <button class="save-button medication-button" (click)="AddMedicationPCC()">Save Medications</button>
              <button class="save-button medication-sync-button" (click)="addCarePeriod()" >Add Care Period</button>
             
            </div>
            
            
          </div>
  
        </div>
       
  
      
        <div class="popup-divider" *ngIf="showAddCarePeriod"></div>
      
        <div class="popup-section create-section"  *ngIf="showAddCarePeriod" >
          <h3 class="section-title">Create New Care Period</h3>
          <div class="section-content">


            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="carePeriodType">Care Period Type:</label>
                  <select id="carePeriodType" class="form-control">
                    <option value="ENCOUNTER">ENCOUNTER</option>
                    <option value="PATIENT_HISTORY">PATIENT HISTORY</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="carePeriodName">Care Period Name:</label>
                  <input type="text" id="carePeriodName" class="form-control">
                </div>
              </div>
            </div>


        
            
           
            
            <div class="row">
              
              <div class="col-md-6">
                <div class="form-group">
                  <mat-form-field>
                    <mat-label>Start Date:</mat-label>
                  <input id="startDateInput"  matInput [matDatepicker]="startDate" placeholder="Start Date"  />
                  <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                  <mat-datepicker #startDate></mat-datepicker>
                </mat-form-field>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group">
                  <mat-form-field>
                    <mat-label>End Date</mat-label>
                  <input id="endDateInput"  matInput [matDatepicker]="endDate" placeholder="End Date"  />
                  <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                  <mat-datepicker #endDate></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

            
              
             
            </div>
            
            <button class="save-button create-button" (click)="AddCarePeriodPCC()">Create Care Period</button>
          </div>
          <div class="errorGroup" *ngFor="let errors of addCarePeriodErrors">{{errors.detail}}</div>
        </div>
      
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <!-- <button mat-flat-button color="primary">Save</button> -->
    </mat-dialog-actions>
  </ng-template>
  
  <ng-template #medicationDialog>
    <form [formGroup]="medicationForm">
      <h2 mat-dialog-title>
        <ng-container *ngIf="this.medicationID>0; else showAddName">
          Update Medication
        </ng-container>
        <ng-template #showAddName>
          Add Medication
        </ng-template>
  
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
      
      <mat-dialog-content class="mat-typography">
        <div class="form-grid">
          <!-- Row 1: Name and Route -->
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Medication Name</mat-label>
              <input matInput formControlName="Name" required>
              <mat-error *ngIf="medicationForm.get('Name').invalid">
                Medication name is required
              </mat-error>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Route</mat-label>
              <mat-select formControlName="Route" required>
                <mat-option *ngFor="let option of routeOptions" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('Route').invalid">
                Route is required
              </mat-error>
            </mat-form-field>
          </div>
  
          <!-- Row 2: Dosage and Dosage UOM -->
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Dosage</mat-label>
              <input matInput formControlName="Dosage" required>
              <mat-error *ngIf="medicationForm.get('Dosage').invalid">
                Dosage is required
              </mat-error>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Dosage UOM</mat-label>
              <mat-select formControlName="Dosage_UOM" required>
                <mat-option *ngFor="let option of dosageUomOptions" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('Dosage_UOM').invalid">
                Dosage UOM is required
              </mat-error>
            </mat-form-field>
          </div>
  
          <!-- Row 3: Schedule and Schedule Type -->
          <div class="form-row">
            <mat-form-field appearance="outline" class="mat-form-field3">
              <mat-label>Schedule</mat-label>
              <mat-select formControlName="Schedule" required>
                <mat-option *ngFor="let option of scheduleOptions" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('Schedule').invalid">
                Schedule is required
              </mat-error>
            </mat-form-field>
  
            <mat-form-field appearance="outline" class="mat-form-field3">
              <mat-label>Schedule Type</mat-label>
              <mat-select formControlName="ScheduleType" (selectionChange)="onScheduleTypeChange()">
                <mat-option *ngFor="let option of scheduleTypeOptions" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('ScheduleType').invalid && medicationForm.get('Schedule').value == 'Routine'">
                Schedule Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mat-form-field3">
              <mat-label>Alternate Schedule Type</mat-label>
              <input matInput formControlName="AlternateScheduleType" [disabled]="medicationForm.get('ScheduleType').value !== 'Other'">
              <mat-error *ngIf="medicationForm.get('AlternateScheduleType').invalid && medicationForm.get('ScheduleType').value == 'Other'">
                Alternate Schedule Type is required
              </mat-error>
            </mat-form-field>
          </div>
  
          <!-- Row 4: Alternate Schedule Type and Frequency -->
          <div class="form-row">
         
  
            <mat-form-field appearance="outline">
              <mat-label>Frequency</mat-label>
              <mat-select formControlName="Frequency" (selectionChange)="onFrequencyChange()">
                <mat-option *ngFor="let option of frequencyOptions" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('Frequency').invalid && medicationForm.get('Schedule').value == 'Routine'">
                Frequency is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Alternate Frequency</mat-label>
              <input matInput formControlName="AlternateFrequency" [disabled]="medicationForm.get('Frequency').value !== 'Other'">
              <mat-error *ngIf="medicationForm.get('AlternateFrequency').invalid && medicationForm.get('Frequency').value == 'Other'">
                Alternate Frequency is required
              </mat-error>
            </mat-form-field>
          </div>
  
          <!-- Row 5: Alternate Frequency and PRN Timing -->
          <div class="form-row">
           
            <mat-slide-toggle style="width: 29% !important;" [disabled]="medicationForm.get('Schedule').value != 'PRN'"
                formControlName="IsPrnWithDirections"  (change)="onPRNWithTimeChange($event)"
                color="primary">
                PRN With Time
            </mat-slide-toggle>

            <mat-form-field appearance="outline" class="mat-form-field3">
              <mat-label>PRN Timing</mat-label>
              <mat-select formControlName="PrnTiming" [disabled]="!medicationForm.get('IsPrnWithDirections').value">
                <mat-option *ngFor="let option of prnTimingOptions" [value]="option">
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('PrnTiming').invalid && medicationForm.get('Schedule').value == 'PRN'">
                PRN Timing is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="mat-form-field3">
              <mat-label>PRN Timing Value</mat-label>
              <input matInput formControlName="PrnTimingValue" [disabled]="medicationForm.get('IsPrnWithDirections').value==false">
              <mat-error *ngIf="medicationForm.get('PrnTimingValue').invalid && medicationForm.get('Schedule').value == 'PRN'">
                PRN Timing Value is required
              </mat-error>
            </mat-form-field>            
          </div>
  
           <!-- Row 6: End Date and Status -->
          <div class="form-row">
           
             <mat-form-field appearance="outline">
               <mat-label>Indication</mat-label>
               <textarea matInput formControlName="IndicationsForUse" rows="3"></textarea>
            </mat-form-field>

             <mat-form-field appearance="outline">
               <mat-label>Additional Directions</mat-label>
               <textarea matInput formControlName="AdditionalDirections" rows="3"></textarea>
               <mat-error *ngIf="medicationForm.get('AdditionalDirections').invalid">
                Additional Directions is required
              </mat-error>
            </mat-form-field>
            
          </div>
          <!-- Row 7: PRN Timing Value and Start Date -->
          <div class="form-row">
           <mat-form-field appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select formControlName="Status" required>
                <mat-option *ngFor="let option of statusOptions" [value]="option"> 
                  {{option}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="medicationForm.get('Status').invalid">
                Status is required
              </mat-error>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Start Date</mat-label>
              <!-- <input matInput type="date" formControlName="StartDate"> -->
              <input  matInput formControlName="StartDate" [matDatepicker]="startDate" placeholder="Start Date"  />
              <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>End Date</mat-label>
              <!-- <input matInput type="date" formControlName="EndDate"> -->
              <input  matInput formControlName="EndDate" [matDatepicker]="endDate" placeholder="End Date"  />
              <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>
  
          </div>
  
         
        </div>
      </mat-dialog-content>
  
      <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="closeMedPopup()">Cancel</button>
        <button *ngIf="this.medicationID>0" mat-flat-button color="primary"  
          [disabled]="medicationForm.invalid || !medicationForm.dirty"  
          (click)="updateMedication()">
          Update
        </button>
        <button *ngIf="this.medicationID==0"  mat-flat-button color="primary"  
          [disabled]="medicationForm.invalid || !medicationForm.dirty"  
          (click)="updateMedication()">
          Add
        </button>
      </mat-dialog-actions>
    </form>
  </ng-template>
  
  <!-- CSS for the form layout -->
  <style>
  .form-grid {
    /* display: flex; */
    flex-direction: column;
    gap: 5px;
  }
  
  .form-row {
    /* display: grid; */
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  
  mat-form-field {
    width: 100%;
  }

  .mat-form-field3 {
    width: 33.3% !important;
  }
  
  
  .dialog-actions {
    justify-content: flex-end;
    padding: 16px 0;
  }
  </style>

</div>